<template>
  <div>
    <a-card title="库存报表">
      <a-row gutter="16">
        <a-col :span="24" :md="6" :xl="4" style="max-width: 256px; margin-bottom: 12px;">
          <a-input-search v-model="searchForm.search" placeholder="产品编号/名称" allowClear @search="search"/>
        </a-col>
        <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-select v-model="searchForm.warehouse" placeholder="仓库" allowClear style="width: 100%;" @change="search">
            <a-select-option :value="null">所有仓库</a-select-option>
            <a-select-option v-for="item in warehouseItems" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-select v-model="searchForm.has_stock" placeholder="库存状态" allowClear style="width: 100%;"
                    @change="search">
            <a-select-option :value="true">有库存</a-select-option>
            <a-select-option :value="false">无库存</a-select-option>
          </a-select>
        </a-col>
        <a-col v-if="canViewPurchasePrice" :span="24" :md="4" style="margin-bottom: 12px;">
          <purchase-price-toggle />
        </a-col>
      </a-row>
      <a-alert
          v-if="showPurchasePrice"
          style="margin-top: 12px;"
          type="info"
          message="总价值"
          :description="`¥ ${Number(totalValue || 0).toFixed(2)}`"
          showIcon
      />
      <a-row style="margin-top: 12px;">
        <a-table size="small"
                 rowKey="id"
                 :columns="columns"
                 :dataSource="items"
                 :loading="loading"
                 :pagination="pagination"
                 @change="tableChange">
        </a-table>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { warehousesOption } from '@/api/option'
import { inventoryReportList } from '@/api/report'
import purchasePriceVisibility from '@/mixins/purchasePriceVisibility'

export default {
  name: 'Warehouse',
  mixins: [purchasePriceVisibility],
  components: {
    PurchasePriceToggle: () => import('@/components/PurchasePriceToggle/index.vue'),
  },
  data() {
    return {
      searchForm: { page: 1, page_size: 16, warehouse: null, has_stock: true },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      totalValue: 0,
      warehouseItems: [],
    }
  },
  computed: {
    ...mapState({
      isManager: (state) => state.user.isManager,
      permissions: (state) => state.user.permissions || [],
    }),
    purchasePriceAuth() {
      return { isManager: this.isManager, permissions: this.permissions }
    },
    columns() {
      const cols = [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => index + 1,
          width: 45,
        },
        { title: '产品名称', dataIndex: 'goods_name' },
        { title: '产品编号', dataIndex: 'goods_number' },
        { title: '库存总数', dataIndex: 'total_quantity' },
      ]
      if (this.showPurchasePrice) {
        cols.push(
          { title: '进货价', dataIndex: 'purchase_price' },
          {
            title: '总价值',
            dataIndex: 'total_value',
            customRender: (value, item) => {
              const n = Number(item.total_quantity) * Number(item.purchase_price || 0)
              return Number.isFinite(n) ? n.toFixed(2) : '0.00'
            },
          },
        )
      }
      cols.push(
        { title: '单位', dataIndex: 'unit_name', width: 80 },
        {
          title: '库存状态',
          dataIndex: 'has_stock',
          customRender: (value, item) => (item.has_stock ? '有' : '无'),
        },
      )
      return cols
    },
  },
  methods: {
    initialize() {
      warehousesOption({ page_size: 99999 }).then((resp) => {
        this.warehouseItems = resp.results
      })
      this.list()
    },
    list() {
      this.loading = true
      inventoryReportList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count
          if (this.searchForm.warehouse === null) {
            this.items = data.results.results
            this.totalValue = data.results.total_value
          } else {
            this.items = data.results
            this.totalValue = data.total_value
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current
      this.pagination.current = pagination.current
      this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`
      this.list()
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
  },
  mounted() {
    this.initialize()
  },
}
</script>
